import React from "react";

import { Logo } from "@/components/Logo";

import { useMessageListStyles } from "./styles";

const LoadingMessage: React.FC = () => {
  const styles = useMessageListStyles();

  return (
    <div className={styles.assistantMessage}>
      <div className={styles.avatar}>
        <Logo size={18} withoutText />
        <span className={styles.typingIndicator}>
          Thinking...
        </span>
      </div>
    </div>
  );
};

export default LoadingMessage;
